import React from 'react';
import { Button, Icon, Popup, Table, Header, Divider, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';
import AddNewCourse from './AddNewCourse';


export default class MobilityCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            mob: JSON.parse(localStorage.getItem('mob')),
            limitation: this.props.limitation,
        };
        this.getMobilityCourses = this.getMobilityCourses.bind(this);
        this.deleteMobilityCourse = this.deleteMobilityCourse.bind(this);
    }

    componentDidMount() {
        this.getMobilityCourses();
    }

    getMobilityCourses() {
        this.setState({ loader: true });
        axios.get(`/student-study-program-mobility/courses/${this.state.mob.id}/`)
            .then(res => {
                let courses = res.data;
                this.setState({ courses });
                this.setState({ loader: false });
            });
    }

    deleteMobilityCourse(courseStudyProgramId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: this.state.mob.id,
            courseStudyPrograms: [{ id: courseStudyProgramId }],
            optLock
        };
        axios.delete('/student-study-program-mobility/remove-courses/', { data: obj })
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali predmet!');
                this.getMobilityCourses();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Predmet nije izbrisan!');
            });
    }


    render() {
        return (
            <div>
                <Divider horizontal>
                    <Header as="h4">{this.state.mob.universityName}<br />
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>{this.state.mob.country.officialName}</i></span>
                    </Header>
                </Divider>

                {!this.state.onButtonClick && !this.state.limitation ?
                    <Header style={IconHeader} floated="right">
                        <Button
                            floated="right"
                            icon
                            labelPosition="right"
                            color="blue"
                            disabled={this.state.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                            style={FiltersOnStyle}
                            onClick={() => { this.setState({ addCourse: true, onButtonClick: true }); window.scrollTo(0, 0); }}
                        ><Icon className="add" />
                            Dodaj predmet
                        </Button></Header>
                    : !this.state.limitation && <br />}

                {this.state.addCourse && <div><AddNewCourse
                    getMobilityCourses={this.getMobilityCourses}
                    closeAddMode={() => this.setState({ addCourse: false, onButtonClick: false })}
                /> <br /></div>}

                {(this.state.courses.length && !this.state.limitation) ? <div><br /><br /></div> : ''}
                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.courses.length ?
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={3}>Predmet</Table.HeaderCell>
                                    <Table.HeaderCell >Šifra</Table.HeaderCell>
                                    <Table.HeaderCell width="2">P / V</Table.HeaderCell>
                                    <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                    <Table.HeaderCell >Tip predmeta</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={1} />
                                </Table.Row>
                            </Table.Header>

                            <Table.Body> {this.state.courses.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle"colSpan={3}>
                                        {el.courseBasic.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="1">
                                        {el.code}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="1">
                                        {el.exerciseNumber}/{el.lectureNumber}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.ects}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.mandatory ? 'obavezni' : 'izborni'}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                        {this.state.confirmation === index ?
                                            <div>
                                                <h4>Jeste li sigurni?</h4>
                                                <Button.Group>
                                                    <Button
                                                        basic="true"
                                                        color="blue"
                                                        onClick={() => this.deleteMobilityCourse(el.id, el.optLock)}
                                                    > DA</Button>
                                                    <Button
                                                        basic="true"
                                                        color="red"
                                                        onClick={(e) => { this.setState({ confirmation: false }); }}
                                                    >  NE

                                                    </Button>
                                                </Button.Group></div>
                                            : <div>
                                                <Popup
                                                    content="Brisanje predmeta"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.limitation || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="small"
                                                            color="red"
                                                            onClick={() => this.setState({ confirmation: index })}
                                                        />}
                                                /></div>}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : <div><br /><br />Nema predmeta kojih je student oslobođen na osnovu odabrane mobilnosti.</div>}
                <ToastContainer hideProgressBar />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/MobilityCourses.js